var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 5.26806C26.9587 5.7205 25.8492 6.0204 24.6925 6.16601C25.8825 5.46221 26.7908 4.35625 27.2178 3.02319C26.1083 3.67845 24.8832 4.14129 23.5777 4.39958C22.5242 3.28842 21.0227 2.60022 19.3847 2.60022C16.2067 2.60022 13.6482 5.15539 13.6482 8.2878C13.6482 8.73851 13.6867 9.17188 13.7812 9.58445C9.009 9.3539 4.78625 7.08823 1.9495 3.63685C1.45425 4.48799 1.16375 5.46221 1.16375 6.51097C1.16375 8.48022 2.1875 10.2258 3.7135 11.2365C2.79125 11.2191 1.8865 10.9539 1.12 10.5361C1.12 10.5535 1.12 10.576 1.12 10.5985C1.12 13.3617 3.10975 15.6569 5.719 16.1856C5.25175 16.3121 4.7425 16.3728 4.214 16.3728C3.8465 16.3728 3.4755 16.352 3.12725 16.2757C3.871 18.5275 5.9815 20.183 8.491 20.2368C6.538 21.7501 4.05825 22.6619 1.37375 22.6619C0.903 22.6619 0.4515 22.6411 0 22.5839C2.54275 24.2082 5.55625 25.1356 8.806 25.1356C19.369 25.1356 25.144 16.4681 25.144 8.9552C25.144 8.70384 25.1352 8.46115 25.123 8.2202C26.2622 7.41932 27.2195 6.4191 28 5.26806Z",
    fill: "#03A9F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 27.7358,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.8f464c200956f06e5d372c6d092fa2fa.svg";
export { ForwardRef as ReactComponent };